import { Paper, Image, Title } from "@mantine/core";
import { RiVipCrownFill } from "react-icons/ri";
import { useEffect, useState } from "react";
import { useQuery } from "@apollo/client";
import { GET_LEADERBOARD } from "../../../queries/contest";
import PLTrend from "../PLTrend/PLTrend";

import "./UserContestCard.css";

const UserContestCard = ({
  user,
  contestRanking,
  contestAttended,
  contestname,
}) => {
  const [globalLeaderboard, setGlobalLeaderboard] = useState([]);
  const { loading: globalLeaderboardQueryLoading, 
    error: globalLeaderboardQueryError, 
    data: globalLeaderboardQueryData } = useQuery(GET_LEADERBOARD);
  
  useEffect(() => {
    if (globalLeaderboardQueryLoading) { }
    else if (globalLeaderboardQueryError) console.log(globalLeaderboardQueryError)
    else {
        setGlobalLeaderboard(globalLeaderboardQueryData.getLeaderboard);
    }
  }, [globalLeaderboardQueryLoading, globalLeaderboardQueryError, globalLeaderboardQueryData]);

  // Calculate the user's global ranking
  const globalRanking = globalLeaderboard.findIndex(
    (entry) => entry.userid === user?.userid
  ) + 1; // Adding 1 because findIndex is zero-based
  
  return (
    <Paper
      shadow="sm"
      radius="md"
      withBorder
      pt="md"
      pb="xs"
      mx="sm"
      className="card"
    >
      <div className="user-contest-container">
        {user ? (
          <div>
            <div className="user-details">
              <Image
                className={
                  contestRanking <= 3
                    ? "rank " +
                      (contestRanking === 1
                        ? "gold"
                        : contestRanking === 2
                        ? "silver"
                        : "bronze")
                    : ""
                }
                alt="user image"
                src="/logo512.png"
                width={100}
                fit="cover"
                radius={9999}
              />
              {contestRanking === 1 ? (
                <RiVipCrownFill className="crown" />
              ) : null}
              <div className="user-info">
                <Title order={2}>{user.alias}</Title>
                <p>
                  <b>Global Ranking:</b> {globalRanking}
                </p>
                {/* <p>
                  <b>Contest Attended:</b> {contestAttended}
                </p> */}
              </div>
            </div>
            <div>
              <h3 className="chart-header">P/L for {contestname}</h3>
              <PLTrend userid={user.userid} />
            </div>
          </div>
        ) : (
          <div className="no-user-selected">No User Selected</div>
        )}
      </div>
    </Paper>
  );
};

export default UserContestCard;
